import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FeedbackService, FeedbackPayload } from '../../service/feedback.service';

@Component({
  standalone: false,
  selector: 'acu-feedback',
  templateUrl: './acu-feedback.component.html',
  styleUrls: ['./acu-feedback.component.scss']
})
export class AcuFeedbackComponent {
  @Input() context: string = 'general';
  @Output() feedbackDone = new EventEmitter<void>();

  rating: number = 0;
  comment: string = '';
  suggestion: string = '';
  isSubmitted: boolean = false;
  isSubmitting: boolean = false;
  stars = [1, 2, 3, 4, 5];

  constructor(private feedbackService: FeedbackService) {}

  setRating(val: number) {
    if (this.isSubmitted) return;
    this.rating = val;
  }

  async submit() {
    if (this.rating === 0 || this.isSubmitting) return;
    this.isSubmitting = true;

    const isCritical = this.rating <= 2;
    const trimmedSuggestion = this.suggestion ? this.suggestion.trim() : '';
    const trimmedComment = this.comment ? this.comment.trim() : '';

    const payload: FeedbackPayload = {
      rating: this.rating,
      comment: isCritical ? (trimmedSuggestion || trimmedComment) : trimmedComment,
      suggestion: isCritical && trimmedSuggestion ? trimmedSuggestion : undefined,
      context: this.context
    };
    try {
      await this.feedbackService.submitFeedback(payload);
    } catch (e) {
      // Even if backend fails, we record it as done client-side to avoid annoying user
      console.warn('[Feedback] Submit failed, still marking as shown:', e);
    }
    this.feedbackService.markFeedbackShown();
    this.isSubmitting = false;
    this.isSubmitted = true;
  }

  skip() {
    this.feedbackService.markFeedbackShown();
    this.feedbackDone.emit();
  }

  close() {
    this.feedbackDone.emit();
  }
}
